import {SellerError} from './SellerError.js'

export class GetCloseDealersNotFoundSellerError extends SellerError {}
